import i18n                 from 'i18next';
import { initReactI18next } from 'react-i18next';
import ChainedBackend       from 'i18next-chained-backend';
import HttpBackend          from 'i18next-http-backend';
import LocalStorageBackend  from 'i18next-localstorage-backend';

// There is a single translations source for the whole app — no per-domain locale switching.
const LOCALE = 'by';

let initPromise = null;

export default function i18nextInit() {
  if (initPromise) {
    return initPromise;
  }

  if (isSSR()) {
    // Populated synchronously by node/ssr-server.js from translations/messages.json
    // before the bundle is required, so this is a plain in-memory read, no I/O here.
    initPromise = i18n.use(initReactI18next).init({
      resources:     {
        [LOCALE]: {translation: global.__TRANSLATIONS__ || {}},
      },
      lng:           LOCALE,
      fallbackLng:   LOCALE,
      interpolation: {
        escapeValue: false,
      },
      nsSeparator: '@',
    });
  } else {
    initPromise = i18n.use(ChainedBackend).use(initReactI18next).init({
      backend:       {
        backends:       [LocalStorageBackend, HttpBackend],
        backendOptions: [
          {defaultVersion: BUILD_TIME, store: typeof window !== 'undefined' ? window.localStorage : null},
          {loadPath: '/api/translations'},
        ],
      },
      lng:           LOCALE,
      debug:         false,
      fallbackLng:   LOCALE,
      load:          'currentOnly',
      saveMissing:   false,
      react:         {
        useSuspense: false,
        wait:        false,
        bindI18n:    'languageChanged loaded',
        bindStore:   'added removed',
        nsMode:      'default',
      },
      interpolation: {
        escapeValue: false,
      },
      nsSeparator: '@',
    });
  }

  return initPromise;
}
